import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
    standalone: false ,  // NOSONAR
})
export class LandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { // NOSONAR
		//  do something 
	}

}
